import { CProgress, CProgressBar } from '@coreui/react-pro';
import { CSSProperties, JSX, useEffect, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router';

import { navigationProgress } from './navigationProgressStore';

// Jediné „custom" CSS: fixní pozice přes celou šířku nahoře (CoreUI nemá top-bar
// primitivum) + fade-out. Samotný pruh je CoreUI CProgress/CProgressBar, stejně
// jako DataLoadProgress — barva `primary` (indigo) dle brand manuálu, červená je
// signální (≤10 %). Časování fade musí sedět s FINISH_FADE_MS ve storu.
const wrapperStyle = (finishing: boolean): CSSProperties => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 2000, // nad sticky AppHeader
  opacity: finishing ? 0 : 1,
  // Celková délka (300 ms) musí být <= FINISH_FADE_MS ve storu, ať se bar stihne
  // doblednout, než ho store odmountuje.
  transition: 'opacity 300ms ease-in',
  pointerEvents: 'none',
});

/**
 * Globální top-bar indikátor navigace mezi routami. Naběhne při změně routy a
 * schová se, jakmile se nová stránka namountuje — kryje díru KLIK → MOUNT u lazy
 * chunků (viz komentář v navigationProgressStore). Renderuje se jednou, uvnitř
 * <BrowserRouter> (potřebuje useLocation), nad layoutem.
 */
const NavigationProgress = (): JSX.Element | null => {
  const { pathname } = useLocation();
  const state = useSyncExternalStore(
    navigationProgress.subscribe,
    navigationProgress.getSnapshot,
    navigationProgress.getSnapshot,
  );

  // useLocation se aktualizuje až po commitu transition = nová routa je namountovaná.
  useEffect(() => {
    navigationProgress.commit(pathname);
  }, [pathname]);

  if (!state.active) return null;

  const finishing = state.progress >= 1;
  return (
    <div style={wrapperStyle(finishing)} role="presentation" aria-hidden="true">
      <CProgress height={3} className="rounded-0">
        <CProgressBar color="primary" value={state.progress * 100} animated variant="striped" />
      </CProgress>
    </div>
  );
};

export default NavigationProgress;
